var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGameRules(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,360.14a20.43,20.43,0,1,1-20.43,20.43A20.51,20.51,0,0,1,256,360.14ZM238.38,129.83c0-11.62,6.81-18.83,17.62-18.83s17.62,7.21,17.62,18.83V303.26c0,11.62-6.81,18.83-17.62,18.83s-17.62-7.21-17.62-18.83ZM256,480C132.47,480,32,379.51,32,256S132.47,32,256,32,480,132.49,480,256,379.5,480,256,480Zm0-416C150.12,64,64,150.13,64,256s86.13,192,192,192,192-86.13,192-192S361.86,64,256,64Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGameRules);
export default __webpack_public_path__ + "static/media/icon-game-rules.52ce8c87.svg";
export { ForwardRef as ReactComponent };